import { render, staticRenderFns } from "./WarnCardListImage.vue?vue&type=template&id=4160d274&scoped=true"
import script from "./WarnCardListImage.vue?vue&type=script&lang=js"
export * from "./WarnCardListImage.vue?vue&type=script&lang=js"
import style0 from "./WarnCardListImage.vue?vue&type=style&index=0&id=4160d274&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4160d274",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4160d274')) {
      api.createRecord('4160d274', component.options)
    } else {
      api.reload('4160d274', component.options)
    }
    module.hot.accept("./WarnCardListImage.vue?vue&type=template&id=4160d274&scoped=true", function () {
      api.rerender('4160d274', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/warnrecord/components/WarnCardListImage.vue"
export default component.exports